module.exports = __webpack_public_path__ + "img/natcash.10d0f0f4.png";